<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Planned - Driver Utilization Daily</span><br/>
      <span style="font-style: italic; font-size: 18px">this view shows all drivers and any scheduled bookings times for the selected date.  Select a row for more details</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>

    <div v-if="!loading" style="font-size: 22px; font-weight: bold; margin-top: 20px; margin-bottom: 20px">
      <span style="float: left; border-radius: 5px; padding: 8px; border: 1px solid grey;">Showing {{items.length}} of {{summary.total_cnt}}</span>
        &nbsp;
        Driver Tags:&nbsp;<b-form-select v-model="selected_driver_tag" :options="driver_tags_options" style="font-size: 18px; width:260px"/>
        &nbsp;
        Start Base:&nbsp;<b-form-select v-model="selected_start_base" :options="start_base_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      <span style="float: right">
        <b-button v-on:click.prevent="reset_filters()">Reset</b-button>
      </span>
    </div>
    <div v-if="!loading">
      <table width="100%" border='1' cellpadding='0' cellspacing="0">
          <tr>
          <th colspan="11">&nbsp;</th>
          <th style='background-color: #ddd;' colspan="24">{{this.details_fromDate}}</th>
          </tr>
          <tr>
            <th width="80px" @click="sort_strings('driver')">Driver &#8597;</th>
            <th width="90px" @click="sort_numbers('charterIDs')">Booking &#8597;</th>
            <th width="80px" @click="sort_strings('vehicles')">Vehicle &#8597;</th>
            <th width="80px" @click="sort_strings('start_bases')">Base &#8597;</th>
            <th width="80px" @click="sort_strings('first_pickup')">Pickup</th>
            <th width="80px" @click="sort_strings('last_destination')">Destination</th>
            <th style="background-color: green; color: white" width="100px" @click="sort_dates('start_datetime')">Start &#8597;</th>
            <th style="background-color: grey; color: white" width="100px" @click="sort_dates('arrival_datetime')">Arrival &#8597;</th>
            <th style="background-color: green; color: white" width="100px" @click="sort_dates('leave_datetime')">Leave &#8597;</th>
            <th style="background-color: orange; color: white" width="100px" @click="sort_dates('complete_datetime')">Complete &#8597;</th>
            <th style="background-color: darkred; color: white" width="100px" @click="sort_dates('finish_datetime')">Finish &#8597;</th>
            <th width="15px" style="background-color: #ddd; font-size: 12px; font-weight: bold" v-for="hour in hours_display">{{hour}}</th>
          </tr>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{item.driver | trim(20)}}</td>
            <td>{{item.charterIDs | trim(20)}}</td>
            <td>{{item.vehicles | trim(20)}}</td>
            <td>{{item.start_bases | trim(20)}}</td>
            <td>{{item.first_pickup | trim(20)}}</td>
            <td>{{item.last_destination | trim(20)}}</td>
            <td>{{item.start_datetime | formatDateTimeSmall}}</td>
            <td>{{item.arrival_datetime | formatDateTimeSmall}}</td>
            <td>{{item.leave_datetime | formatDateTimeSmall}}</td>
            <td>{{item.complete_datetime | formatDateTimeSmall}}</td>
            <td>{{item.finish_datetime | formatDateTimeSmall}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,15)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,30)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,45)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,60)'>&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr v-if="item.isMvmtsVisible" v-for="assignment in item.assignments">
            <td colspan="1" align="right" style="font-weight: bold">&nbsp;</td>
            <td>{{ assignment.charterID }}</td>
            <td>{{ assignment.vehicle }}</td>
            <td>{{ assignment.start_base | trim(20) }}</td>
            <td>{{ assignment.pickup | trim(20)}}</td>
            <td>{{ assignment.destination | trim(20)}}</td>
            <td>{{assignment.start_datetime | formatDateTimeSmall}}</td>
            <td>{{assignment.arrival_datetime | formatDateTimeSmall}}</td>
            <td>{{assignment.leave_datetime | formatDateTimeSmall}}</td>
            <td>{{assignment.complete_datetime | formatDateTimeSmall}}</td>
            <td>{{assignment.finish_datetime | formatDateTimeSmall}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,15,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,30,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,45,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,60,'lightgreen')">&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import {get_driver_utilization} from "../networking/apis";

export default {
  name: 'planned_drivers_daily',

  components: {
  },

  data() {
    return {
      vehicle_status_disabled: false,
      items: [],
      items_full: [],
      reloading: false,
      reload_mode: 0,
      timer: null,
      selected_driver_tag: '',
      selected_start_base: '',
      summary: [],
      hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      hours_display: ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'],
      quarters: [0,15,30,45],
      loading: true,
      details_fromDate: justDate(moment()),
      driver_tags_options: [],
      location_options: [],
      start_base_options: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.vehicle_status_disabled = !this.user.features[this.user.tenant].vehicle_status_management_enabled
      this.load_data()
    },
    async reset_filters() {
      this.selected_driver_tag = ''
      this.selected_start_base = ''
    },
    async load_data() {
      this.loading = true
      try {
        this.sort_col = 'vehicle'

        const { value: { data = [] }} = await get_driver_utilization(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.driver_tags_options = data.summary.driver_tags
        this.start_base_options = data.summary.start_bases
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    getStyleForMvmt(fromDate,hour,mvmt,minutes,color) {
      //console.log("mvmt:" + JSON.stringify(mvmt))
      let slice_found = false;
      let fromDateObj = moment(fromDate,'MM-DD-YYYY')

      var start_datetime = moment(mvmt.start_datetime)
      var arrival_datetime = moment(mvmt.arrival_datetime)
      var leave_datetime = moment(mvmt.leave_datetime)
      var complete_datetime = moment(mvmt.complete_datetime)
      var finish_datetime = moment(mvmt.finish_datetime)

      let start_date = start_datetime.format('MM-DD-YYYY')
      let arrival_date = arrival_datetime.format('MM-DD-YYYY')
      let leave_date = leave_datetime.format('MM-DD-YYYY')
      let complete_date = complete_datetime.format('MM-DD-YYYY')
      let finish_date = finish_datetime.format('MM-DD-YYYY')

      let start_hour = start_datetime.format('HH')
      let start_min = start_datetime.format('mm')
      let arrival_hour = arrival_datetime.format('HH')
      let arrival_min = arrival_datetime.format('mm')
      let leave_hour = leave_datetime.format('HH')
      let leave_min = leave_datetime.format('mm')
      let complete_hour = complete_datetime.format('HH')
      let complete_min = complete_datetime.format('mm')
      let finish_hour = finish_datetime.format('HH')
      let finish_min = finish_datetime.format('mm')

      //console.log("checking " + fromDate + ":" + hour + ":" + minutes + " against " + mvmt.start_datetime + ":" + start_hour + ":" + start_min + " - " + mvmt.finish_datetime + ":" + finish_hour + ":" + finish_min);
      // console.log("checking " + fromDate + ":" + hour + ":" + minutes);
      // console.log("mvmt     " + mvmt.start_datetime + ":" + start_hour + ":" + start_min + " - " + mvmt.finish_datetime + ":" + finish_hour + ":" + finish_min);
      //console.log("comp: " + start_date + " <= " + fromDateObj + " && " + fromDateObj + " <= " +finish_date);

      // if (fromDate == finish_date.format('MM-DD-YYYY')  && (hour == finish_hour && (minutes - finish_min) == 15))
      //   return 'background-image: linear-gradient(90deg, darkred 30%, white 70%)';

      if (start_date < fromDate && fromDate < finish_date) {
        slice_found = true;
      }
      else if (start_date < fromDate && finish_date >= fromDate) {
        if (hour < finish_hour || (hour == finish_hour && finish_min >= minutes )) {
          slice_found = true;
        }
      }
      else if (finish_date > fromDate && start_date <= fromDate) {
        if (start_hour < hour || (hour == start_hour && start_min <= minutes )) {
          slice_found = true;
        }
      }
      else if (start_date <= fromDate && fromDate <= finish_date) {

        //console.log("partial day found: " + hour + "," + start_hour + ":" + finish_hour);

        if (start_hour == finish_hour && start_min == finish_min) {
          //console.log("start == finish");
        }
        else if (start_hour < hour && hour < finish_hour) {
          //console.log("complete hour found");
          slice_found = true;
        }
        else if (start_hour <= hour && hour <= finish_hour) {
          //console.log("partial hour found: " + hour);
          if (start_hour == hour && start_min < minutes) {
            //console.log("start minute found");
            slice_found = true;
          }
          else if (finish_hour == hour && finish_min >= minutes) {
            //console.log("finish minute found");
            slice_found = true;
          }
        }
      }

      if (slice_found) {
        //console.log("slice found");
        if (arrival_datetime && leave_datetime) {
          //console.log(fromDate + " " + hour + ":" + minutes + ", arrival " + arrival_date + " " + arrival_hour + ":" + arrival_min + ", leave " + leave_date + " " + leave_hour + ":" + leave_min);
          if( arrival_datetime < fromDate && leave_date > fromDate)
            return 'background-color: grey';
          else if( arrival_date == fromDate && leave_date == fromDate && ((hour > arrival_hour || (hour == arrival_hour && minutes > arrival_min)) && (hour < leave_hour || (hour == leave_hour && minutes <= leave_min))))
            return 'background-color: grey';
          else if( arrival_date < fromDate && leave_date == fromDate && (hour < leave_hour || (hour == leave_hour && minutes <= leave_min)))
            return 'background-color: grey';
          else if( arrival_date == fromDate && leave_date > fromDate && (hour > arrival_hour || (hour == arrival_hour && minutes > arrival_min)))
            return 'background-color: grey';
        }
        if (fromDate == finish_date  && ((hour == finish_hour && minutes >= finish_min) || (hour+1 == finish_hour && minutes == 60 && finish_min < 15)))
          return 'background-color: darkred';
        if (fromDate >= complete_date && ((hour == complete_hour && minutes > complete_min) || (hour > complete_hour)))
          return 'background-color: orange';
        else
          return 'background-color:' + color;
      }
      else {
        //console.log("no slice found");
        return ''
      }
    },
    getStyleForVeh(fromDate,hour,item,minutes) {
      for (const mvmt of item.assignments) {
        let resp = this.getStyleForMvmt(fromDate, hour, mvmt, minutes,'green');
        if (resp != '')
          return resp;
      }
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_driver_tag != '')
        this.items = this.items.filter(item => (item.driver_tags && item.driver_tags.indexOf(this.selected_driver_tag) != -1))
      if (this.selected_start_base != '')
        this.items = this.items.filter(item => item.start_bases && item.start_bases.indexOf(this.selected_start_base) != -1)
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_driver_tag(val) {
      this.filter_items()
    },
    selected_start_base(val) {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.load_data();
    },
  }
}
</script>
<style scoped>

th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
a {color: darkred}


</style>


